export const __HEADER_HEIGHT_CSS_VAR = "--header-height";
export const HEADER_HEIGHT_CSS_VAR = `var(${__HEADER_HEIGHT_CSS_VAR})`;
